// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plannerCardStyle_plannerCardGrid__SyxwC,
.plannerCardStyle_plannerCardList__\\+CI-C {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  border-radius: var(--border-radius-large);
  overflow: hidden;
  border: 1px solid var(--border);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 {
  height: 200px;
  position: relative;
  max-width: 150px;
  min-width: 150px;
  width: 100%;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2 img,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL {
  position: absolute;
  top: 15px;
  left: 0;
  background-color: rgba(156, 56, 189, 0.8470588235);
  color: var(--white);
  font: var(--body-font-four);
  font-weight: 500;
  padding: 8px 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 0 50px 50px 0;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL img,
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL svg,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL img,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL svg {
  width: 18px;
  display: block;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ {
  padding: 12px;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq {
  margin-bottom: 12px;
  width: 100%;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  margin-bottom: 4px;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC h4,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC h4 {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--secondary-Text);
  text-transform: capitalize;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak {
  display: flex;
  align-items: center;
  gap: 2px;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li {
  width: 12px;
  height: 12px;
  display: flex;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li img,
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li svg,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li img,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_review__uXZjC .plannerCardStyle_rating__-Icak li svg {
  width: 100%;
  height: 100%;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_plannerName__lJiXE,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_nameAndReview__iViFq .plannerCardStyle_plannerName__lJiXE {
  font: var(--body-font-one);
  color: var(--primary-Text);
  text-transform: capitalize;
  font-weight: 600;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn {
  display: flex;
  gap: 5px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn img,
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn svg,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn img,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn svg {
  width: 16px;
  height: 16px;
  display: block;
}
.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn span,
.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ .plannerCardStyle_location__ZkrSn span {
  color: var(--secondary-Text);
  font: var(--body-font-four);
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardList__\\+CI-C,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardList__\\+CI-C {
  flex-direction: row;
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_card__RDiuv,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_card__RDiuv {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 {
  height: 113px;
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 .plannerCardStyle_topLabel__KJPoL {
  top: 8px;
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardDetails__lTRrZ {
  padding: 12px 16px 12px 12px;
  flex: 1 1;
}
.plannerCardStyle_plannerCardGrid__SyxwC:hover,
.plannerCardStyle_plannerCardList__\\+CI-C:hover {
  background-color: #faf4f2;
}
.plannerCardStyle_plannerCardGrid__SyxwC.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2,
.plannerCardStyle_plannerCardList__\\+CI-C.plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2 {
  max-width: 100%;
  min-width: 100%;
}

@media (max-width: 767px) {
  .plannerCardStyle_plannerCardGrid__SyxwC .plannerCardStyle_cardImg__1Npr2,
  .plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_cardImg__1Npr2 {
    height: 160px !important;
    max-width: 100%;
    min-width: 100%;
  }
}
@media (max-width: 575px) {
  .plannerCardStyle_plannerCardList__\\+CI-C .plannerCardStyle_card__RDiuv {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/planner-card/plannerCardStyle.module.scss"],"names":[],"mappings":"AAAA;;EAEC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;EAEA,eAAA;AAAD;AAEC;;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AACF;AACE;;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAEH;AACE;;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kDAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;AAEH;AAAG;;;;EAEC,WAAA;EACA,cAAA;AAIJ;AACC;;EACC,aAAA;AAEF;AAAE;;EACC,mBAAA;EACA,WAAA;AAGH;AADG;;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAIJ;AAFI;;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;AAKL;AAFI;;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAKL;AAHK;;EACC,WAAA;EACA,YAAA;EACA,aAAA;AAMN;AAJM;;;;EAEC,WAAA;EACA,YAAA;AAQP;AAFG;;EACC,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;AAKJ;AADE;;EACC,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mCAAA;AAIH;AAFG;;;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAMJ;AAHG;;EACC,4BAAA;EACA,2BAAA;AAMJ;AACC;;EACC,mBAAA;AAEF;AAAE;;EACC,aAAA;EACA,eAAA;EACA,WAAA;AAGH;AAAE;;EACC,aAAA;AAGH;AADG;;EACC,QAAA;AAIJ;AAAE;;EACC,4BAAA;EACA,SAAA;AAGH;AACC;;EACC,yBAAA;AAEF;AACE;;EACC,eAAA;EACA,eAAA;AAEH;;AAGA;EAIE;;IACC,wBAAA;IACA,eAAA;IACA,eAAA;EAFD;AACF;AAMA;EAEE;IACC,sBAAA;EALD;AACF","sourcesContent":[".plannerCardGrid,\r\n.plannerCardList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n\tborder-radius: var(--border-radius-large);\r\n\toverflow: hidden;\r\n\tborder: 1px solid var(--border);\r\n\ttransition: all 0.2s ease-in-out;\r\n\t// height: 100%;\r\n\tcursor: pointer;\r\n\r\n\t.cardImg {\r\n\t\theight: 200px;\r\n\t\tposition: relative;\r\n\t\tmax-width: 150px;\r\n\t\tmin-width: 150px;\r\n\t\twidth: 100%;\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: center;\r\n\t\t}\r\n\r\n\t\t.topLabel {\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 15px;\r\n\t\t\tleft: 0;\r\n\t\t\tbackground-color: #9c38bdd8;\r\n\t\t\tcolor: var(--white);\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tpadding: 8px 10px;\r\n\t\t\tz-index: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 5px;\r\n\t\t\tborder-radius: 0 50px 50px 0;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 18px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardDetails {\r\n\t\tpadding: 12px;\r\n\r\n\t\t.nameAndReview {\r\n\t\t\tmargin-bottom: 12px;\r\n\t\t\twidth: 100%;\r\n\r\n\t\t\t.review {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\tgap: 5px;\r\n\t\t\t\tmargin-bottom: 4px;\r\n\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.rating {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 2px;\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\twidth: 12px;\r\n\t\t\t\t\t\theight: 12px;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.plannerName {\r\n\t\t\t\tfont: var(--body-font-one);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.location {\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 5px;\r\n\t\t\tpadding-top: 12px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// ==== list design ====\r\n\r\n\t&.plannerCardList {\r\n\t\tflex-direction: row;\r\n\r\n\t\t.card {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.cardImg {\r\n\t\t\theight: 113px;\r\n\r\n\t\t\t.topLabel {\r\n\t\t\t\ttop: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardDetails {\r\n\t\t\tpadding: 12px 16px 12px 12px;\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #faf4f2;\r\n\t}\r\n\t&.plannerCardGrid {\r\n\t\t.cardImg {\r\n\t\t\tmax-width: 100%;\r\n\t\t\tmin-width: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n\t.plannerCardGrid,\r\n\t.plannerCardList {\r\n\t\t.cardImg {\r\n\t\t\theight: 160px !important;\r\n\t\t\tmax-width: 100%;\r\n\t\t\tmin-width: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 575px) {\r\n\t.plannerCardList {\r\n\t\t.card {\r\n\t\t\tflex-direction: column;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plannerCardGrid": `plannerCardStyle_plannerCardGrid__SyxwC`,
	"plannerCardList": `plannerCardStyle_plannerCardList__+CI-C`,
	"cardImg": `plannerCardStyle_cardImg__1Npr2`,
	"topLabel": `plannerCardStyle_topLabel__KJPoL`,
	"cardDetails": `plannerCardStyle_cardDetails__lTRrZ`,
	"nameAndReview": `plannerCardStyle_nameAndReview__iViFq`,
	"review": `plannerCardStyle_review__uXZjC`,
	"rating": `plannerCardStyle_rating__-Icak`,
	"plannerName": `plannerCardStyle_plannerName__lJiXE`,
	"location": `plannerCardStyle_location__ZkrSn`,
	"card": `plannerCardStyle_card__RDiuv`
};
export default ___CSS_LOADER_EXPORT___;
